import { FC, ReactNode, useCallback, useState } from "react";

export type SwipeDirection = "right" | "left" | "up" | "down";
export const Swipeable: FC<{
  children: ReactNode;
  onSwipe: (direction: SwipeDirection) => void;
}> = ({ children, onSwipe }) => {
  const [touchStartX, setTouchStartX] = useState(null);
  const [touchStartY, setTouchStartY] = useState(null);
  const [touchEndX, setTouchEndX] = useState(null);
  const [touchEndY, setTouchEndY] = useState(null);

  const minSwipeDistance = 50;

  const handleTouchStart = useCallback((e) => {
    setTouchEndX(null);
    setTouchEndY(null);
    setTouchStartX(e.targetTouches[0].clientX);
    setTouchStartY(e.targetTouches[0].clientY);
  }, []);

  const handleTouchMove = useCallback((e) => {
    setTouchEndX(e.targetTouches[0].clientX);
    setTouchEndY(e.targetTouches[0].clientY);
  }, []);

  const handleTouchEnd = useCallback(() => {
    if (
      touchStartX === null ||
      touchStartY === null ||
      touchEndX === null ||
      touchEndY === null
    )
      return;

    const distanceX = touchStartX - touchEndX;
    const distanceY = touchStartY - touchEndY;

    if (Math.abs(distanceX) > Math.abs(distanceY)) {
      // Horizontal swipe
      if (Math.abs(distanceX) > minSwipeDistance) {
        if (distanceX > 0) {
          onSwipe?.("left");
        } else {
          onSwipe?.("right");
        }
      }
    } else {
      // Vertical swipe
      if (Math.abs(distanceY) > minSwipeDistance) {
        if (distanceY > 0) {
          onSwipe?.("up");
        } else {
          onSwipe?.("down");
        }
      }
    }
  }, [touchStartX, touchStartY, touchEndX, touchEndY, onSwipe]);

  return (
    <div
      onTouchStart={handleTouchStart}
      onTouchMove={handleTouchMove}
      onTouchEnd={handleTouchEnd}
      className="flex overflow-hidden"
    >
      {children}
    </div>
  );
};
